"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./SlideOutFeat.scss");
var _checkForDangerouslySet = _interopRequireDefault(require("../../utils/checkForDangerouslySet"));
var _CTASection = _interopRequireDefault(require("../CTASection/CTASection"));
var _Image = _interopRequireDefault(require("../Image/Image"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const SlideOutFeat = _ref => {
  let {
    content = {}
  } = _ref;
  const {
    header,
    image,
    text,
    ctas
  } = content;
  const getBackgroundImage = () => {
    if (image?.url || image?.src) {
      return image?.url || image?.src;
    } else {
      return "";
    }
  };
  return /*#__PURE__*/_react.default.createElement("section", {
    className: "slide-out-feat"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "slide-out-feat__content"
  }, header && /*#__PURE__*/_react.default.createElement("h4", {
    className: "slide-out-feat__header"
  }, header), text && !(0, _checkForDangerouslySet.default)(text) && /*#__PURE__*/_react.default.createElement("p", {
    className: "slide-out-feat__text"
  }, text), text && (0, _checkForDangerouslySet.default)(text) && /*#__PURE__*/_react.default.createElement("div", {
    className: "slide-out-feat__text-holder dangerously-set-content",
    dangerouslySetInnerHTML: {
      __html: text
    }
  }), ctas && /*#__PURE__*/_react.default.createElement(_CTASection.default, {
    ctas: ctas
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "slide-out-feat__image-holder"
  }, image?.url && /*#__PURE__*/_react.default.createElement(_Image.default, {
    GatsbyImage: content?.GatsbyImage,
    className: "slide-out-feat__image",
    image: image?.image ? image?.image : null,
    src: getBackgroundImage()
  })), image?.url && /*#__PURE__*/_react.default.createElement(_Image.default, {
    GatsbyImage: content?.GatsbyImage,
    className: "slide-out-feat__image--mobile",
    image: image?.image ? image?.image : null,
    src: getBackgroundImage()
  }));
};
var _default = SlideOutFeat;
exports.default = _default;